import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';
import { ComponentClass } from 'react';
import ComposeSmartPillData from './store/schema/ComposeSmartPillData';
import './mutators/pillMutators';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailComposeSmartPill" */ './lazyIndex')
);

export { ComponentClass, ComposeSmartPillData };
export const ComposeSmartPillBlock = createLazyComponent(lazyModule, m => m.ComposeSmartPillBlock);
export let lazyAddPill = new LazyAction(lazyModule, m => m.addPill);
export let lazyRemovePill = new LazyAction(lazyModule, m => m.removePill);
